import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { Unavailable as RedesignUnavailable } from '../../../pages';
import * as Store from '../../Store';

export type StateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (s: Store.State) => ({
  appConfig: s.flipdish.AppConfig,
  translate: getTranslate(s.locale),
});

export default connect(mapStateToProps)(RedesignUnavailable);
